<template>
  <section class="app-footer">
    <footer class="footer">
      <div class="container-fluid clearfix">
        <span class="text-muted d-block text-center text-sm-left d-sm-inline-block">Copyright © {{ new Date().getFullYear() }}</span>
        <span class="float-none text-muted float-sm-right d-block mt-1 mt-sm-0 text-center"><a href="mailto:hilfe@kindy-app.de" style="color:#9c9fa6;">hilfe@kindy-app.de</a></span>
      </div>
    </footer>
  </section>
</template>

<script>
export default {
  name: 'app-footer'
}
</script>